// React
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// MUI
import { Grid, Box, Button } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Constants
import EntityConstants from "../../../configs/EntityConstants";
import MessageContants from "../../../configs/MessageContants";
// Service
import { get, post, put } from "../../../services/FetchHelper";
import SpinService from "../../../services/SpinService";
// Utils
import {
    InitialBankDetailState,
    BankDetailSchema,
    BankDetailFormFields,
} from "./Configuration.utils";
// Styles
import { StyledDrawerForm } from "../../../configs/GoStyles";
//Third party
import { Form, Formik } from "formik";
import toast from "react-hot-toast";
import GoForm from "../../../components/Inputs/GoForm";
import PermissionConstants from "../../../configs/PermissionConstants";
import usePermissions from "../../../hooks/usePermissions";
const BankDetail = ({ id, onClose }) => {
    const permissions = usePermissions();
    const spinService = SpinService();
    const [bank_detail, setBankDetail] = useState(InitialBankDetailState);

    const getBankDetail = async (id) => {
        spinService.on();
        const response = await get(EntityConstants.BANK_DETAILS + `/${id}`);
        const data = await response.json();
        setBankDetail(data);
        spinService.off();
    };

    const handleSubmit = async (values) => {
        spinService.on();
        const isNewBankDetail = values.id === undefined;
        const url = isNewBankDetail ? EntityConstants.BANK_DETAILS : EntityConstants.BANK_DETAILS + `/${values.id}`;
        const method = isNewBankDetail ? post : put;
        const response = await method(url, { bank_detail: values });
        if ([200, 201].indexOf(response.status) > -1) {
            toast.success(isNewBankDetail ? MessageContants.BANK_DETAIL_CREATED : MessageContants.BANK_DETAIL_UPDATED);
            onClose();
        }
        spinService.off();
    };

    useEffect(() => {
        if (id !== undefined) {
            getBankDetail(Number(id));
        }
    }, [id]);

    return (
        <Formik
            enableReinitialize
            initialValues={bank_detail}
            validationSchema={BankDetailSchema}
            onSubmit={(values) => handleSubmit(values)}
        >
            {({
                values,
                touched,
                errors,
                dirty,
                isSubmitting,
                handleChange,
                handleBlur,
                handleSubmit,
            }) => (
                <Form noValidate onSubmit={handleSubmit}>
                    <StyledDrawerForm>
                        <Grid
                            container
                            maxWidth="sm"
                            rowSpacing={1}
                            columnSpacing={{ xs: 1, sm: 2, md: 2 }}
                        >
                            {BankDetailFormFields.map((formField, index) => {
                                return (
                                    <Grid key={index} item xs={12} sm={12} md={6} lg={6}>
                                        <GoForm
                                            config={formField}
                                            values={values}
                                            touched={touched}
                                            errors={errors}
                                            handleChange={handleChange}
                                        />
                                    </Grid>
                                );
                            })}
                        </Grid>
                        <Box sx={{ p: 2, textAlign: "right" }}>
                            <Button
                                variant="contained"
                                color="error"
                                startIcon={<Iconify icon="eva:close-circle-outline" />}
                                onClick={() => onClose()}
                            >
                                Close
                            </Button>
                            &nbsp;&nbsp;
                            {((values.id === undefined && permissions.has(PermissionConstants.BANK_DETAIL_CREATE)) || (values.id !== undefined && permissions.has(PermissionConstants.BANK_DETAIL_DELETE))) &&
                                <Button
                                    variant="contained"
                                    startIcon={<Iconify icon="eva:save-fill" />}
                                    type="submit"
                                >
                                    {values.id === undefined ? 'Save' : 'Update'}
                                </Button>
                            }
                        </Box>
                    </StyledDrawerForm>
                </Form>
            )}
        </Formik>
    );
};

BankDetail.propTypes = {
    id: PropTypes.number,
    onClose: PropTypes.any,
};

export default BankDetail;
